export default "__VITE_ASSET__CY680Ohl__"